import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import {getNodeFileList} from "api/services/node-service";
import {useCallback} from "react";
import {IGetNodeFileListRequest} from "api/models/request/IGetNodeFileListRequest";
import {FileFlat} from "@models/FileFlat";
import {NodeFileType} from "@models/NodeFileType";

export const useGetNodeFileList = () => {
    const {callAPI, loading} = useWorkspaceApiCall<IGetNodeFileListRequest, FileFlat[]>(getNodeFileList, '', 'getNodeFileList.error');

    const fetchNodeFileList = useCallback(async (editor: any, nodeFileType: NodeFileType) => {
        const response = await callAPI({nodeFileType});

        if(response?.success) {
            editor.storage.setNodeFiles(nodeFileType, response.data);
        }

        return response;
    }, [callAPI])

    return {fetchNodeFileList, isLoading: loading};
}